'use client'

import { ReactNode, useEffect } from 'react'
import { useLocale } from 'next-intl'
import { setCurrentUserLocale } from '@/lib/axios'

type PropsType = {
  children: ReactNode
}

const LocaleProvider = ({ children }: PropsType) => {
  const locale = useLocale()

  useEffect(() => {
    // Set the locale for the axios instance
    setCurrentUserLocale(locale)
  }, [locale])

  return <>{children}</>
}

export default LocaleProvider
